<template lang="html">
    <label :class="[size, {'ui-input-group invert-order': group}]" class="ui-input" :style="{'width': width}">

        <span v-if="label" class="label">
            <span v-html="label"/>
            <span v-if="required" class="label-required">*</span>
        </span>

        <input
            :data-ui="dataUi"
            v-money="{precision, decimal, thousands, prefix, suffix}"
            :disabled="disabled"
            :value="formattedValue"
            :class="design"
            :style="{'color': colorValue}"
            class="input ui-input-money"
            autocomplete="off"
            type="tel"
            @change="change"
        />

        <span v-if="group" class="group">R$</span>
    </label>
</template>

<script>
import defaults from '@/directives/money/options'
import { format, unformat } from '@/directives/money/utils'
import { money } from '@/directives'

export default {
    name: 'ui-input-money',

    directives: {
        money
    },

    props: {
        value: {
            type: [Number, String],
            required: true,
            default: 0
        },
        masked: {
            type: Boolean,
            default: false
        },
        precision: {
            type: Number,
            default: () => defaults.precision
        },
        decimal: {
            type: String,
            default: () => defaults.decimal
        },
        thousands: {
            type: String,
            default: () => defaults.thousands
        },
        prefix: {
            type: String,
            default: () => defaults.prefix
        },
        suffix: {
            type: String,
            default: () => defaults.suffix
        },
        design: {
            type: [String, Object],
            required: false,
        },
        group: {
            type: Boolean,
            default: false,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        label: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        /**
         * Utilize para alterar o tamanho do input
         */
        size: {
            type: String,
            required: false,
            default: 'md'
        },
        /**
            Define a cor do value
        */
        colorValue: {
            type: String,
            default: '#b0b7c2'
        },
        width: {
            type: String,
            required: false,
        },
        dataUi: {
            type: String,
            required: false,
            default: ''
        },
    },
    data () {
        return {
            formattedValue: ''
        }
    },
    watch: {
        value: {
            immediate: true,
            handler (newValue) {
                const formatted = this.masked && typeof newValue === 'string' && newValue.includes(',')
                    ? newValue
                    : format(parseFloat(newValue), this.$props)
                if (formatted !== this.formattedValue) this.formattedValue = formatted
            }
        }
    },
    methods: {
        change (evt) {
            this.$emit('input', this.masked ? evt.target.value : unformat(evt.target.value, this.precision))
        }
    },
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>